import { HOUR_IN_SECONDS } from 'constants/time/hour-in-seconds.const';

export const ADDRESS_EXPIRATION_TIME_IN_SECONDS = 24 * HOUR_IN_SECONDS;
